import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Grow } from "@mui/material";
import { ChatBotContent } from "./ChatBotContent";
import giftCItyLogo from "assets/images/svg/logo-dark.svg";
import { ChatBotModal, GiftCityICon } from "./styles";

export const ChatBot = () => {
  const { pathname } = useLocation();
  const [isChatBotOpen, setIsChatBotOpen] = useState(false);

  const chatBotBtnHandler = () => {
    setIsChatBotOpen((prev) => !prev);
  };

  useEffect(() => {
    if (isChatBotOpen) {
      setIsChatBotOpen(false);
    }
  }, [pathname]);

  return (
    <div>
      {isChatBotOpen ? (
        <Grow in={isChatBotOpen}>
          <ChatBotModal>
            <ChatBotContent chatBotBtnHandler={chatBotBtnHandler} />
          </ChatBotModal>
        </Grow>
      ) : (
        <GiftCityICon>
          <img
            src={giftCItyLogo}
            onClick={chatBotBtnHandler}
            height="100%"
            width="100%"
          />
        </GiftCityICon>
      )}
    </div>
  );
};
